module.exports = __webpack_public_path__ + "static/fonts/Fact-Medium.e4f3e55.ttf";